function listen(el, event, func) {
  if (el.addEventListener) {
    el.addEventListener(event, func);
    return function () {
      el.removeEventListener(event, func)
    }
  } else if (el.attachEvent) {
    el.attachEvent("on" + event, func);
    return function () {
      el.detachEvent("on" + event, func);
    }
  }
}

function contains(wrapper, inner) {
  if ('contains' in wrapper) {
    return wrapper.contains(inner);
  }

  for (var layer = inner; layer && layer.nodeType === 1; layer = layer.parentNode) {
    if (layer === wrapper) {
      return true;
    }
  }

  return false;
}

export default class {
  constructor() {
    this.cloud = null;
    this.anchor = null;
    this.active = false;
    this.unlisteners = [];
    this.spaceBetweenAnchorAndCloud = 20;
    this.spaceBetweenWallAndCloud = 30;
    this.scrollbarHeatareaWidth = 30;
    this.hideTimeoutHandler = null;
    this.hideTimeout = 100;

    this.install();
  }
  install() {
    this.makeCloud();
    this.bindEvents();
  }
  destroy() {
    this.makeRain();
    this.unbindEvents();
  }
  makeCloud() {
    this.cloud = document.createElement('div');
    this.cloud.setAttribute('style', 'position:fixed;top:0;left:0;border:0;margin:0 0 0 -10px;visibility:hidden;box-sizing:border-box;overflow:auto;display:none;border-color:transparent;border-style:solid;z-index:99999;');
    document.body.appendChild(this.cloud);
  }
  makeRain() {
    document.body.removeChild(this.cloud);
  }
  bindEvents() {
    this.unlisteners = [
      listen(document, 'mousemove', this.handleMouseMove.bind(this))
    ];
  }
  unbindEvents() {
    while (this.unlisteners.length) {
      this.unlisteners.pop()();
    }
  }
  request(anchor, html) {
    clearTimeout(this.hideTimeoutHandler);
    this.hideTimeoutHandler = null;
    this.anchor = anchor;
    this.html = html;
    var anchorBox = anchor.getBoundingClientRect();
    var fullWidth = "innerWidth" in window ? window.innerWidth : document.documentElement.offsetWidth;
    var fullHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
    var spaceOnLeft = anchorBox.left;
    var spaceOnRight = fullWidth - anchorBox.right;
    var spaceOnTop = anchorBox.bottom;
    var spaceOnBottom = fullHeight - anchorBox.top;
    this.cloud.style.display = 'block';
    this.cloud.style.visibility = 'hidden';
    this.cloud.style.width = 'auto';
    this.cloud.style.height = 'auto';
    this.cloud.style.top = '-100%';
    this.cloud.style.left = '-100%';
    this.cloud.style.borderWidth = '0';
    this.cloud.innerHTML = html;
    var cloudWidth = this.cloud.clientWidth;
    var onRight = spaceOnRight > spaceOnLeft;
    var spaceX = onRight ? spaceOnRight : spaceOnLeft;
    if (spaceX < cloudWidth) {
      cloudWidth = spaceX - this.spaceBetweenWallAndCloud;
      this.cloud.style.width = cloudWidth + 'px';
    }
    var left;
    var borderLeftWidth = 0;
    var borderRightWidth = 0;
    if (onRight) {
      left = anchorBox.right;
      borderLeftWidth = this.spaceBetweenAnchorAndCloud;
      borderRightWidth = Math.min(fullWidth - left - cloudWidth, this.scrollbarHeatareaWidth);
    }
    else {
      left = spaceX - cloudWidth;
      borderRightWidth = this.spaceBetweenAnchorAndCloud;
    }
    this.cloud.style.left = left + 'px';
    this.cloud.style.borderLeftWidth = borderLeftWidth + 'px';
    this.cloud.style.borderRightWidth = borderRightWidth + 'px';
    var cloudHeight = this.cloud.clientHeight;
    var onTop = spaceOnTop > spaceOnBottom;
    var spaceY = onTop ? spaceOnTop : spaceOnBottom;
    if (spaceY < cloudHeight) {
      cloudHeight = spaceY - this.spaceBetweenWallAndCloud;
      this.cloud.style.height = cloudHeight + 'px';
    }
    var top;
    var borderBottomWidth = 0;
    if (onTop) {
      top = spaceY - cloudHeight;
      borderBottomWidth = Math.min(this.spaceBetweenAnchorAndCloud, this.scrollbarHeatareaWidth);
    }
    else {
      top = anchorBox.top;
      borderBottomWidth = Math.min(fullHeight - top - cloudHeight, this.scrollbarHeatareaWidth);
    }
    this.cloud.style.top = top + 'px';
    this.cloud.style.borderBottomWidth = borderBottomWidth + 'px';
    this.cloud.style.visibility = 'visible';
    this.active = true;
  }
  fadeAway() {
    if (!this.hideTimeoutHandler) return;
    this.cloud.style.visibility = 'hidden';
    this.cloud.style.display = 'none';
    document.body.style.overflow = '';
    this.active = false;
  }
  handleMouseMove(event) {
    if (!this.active)
      return;
    var target = event.target || event.srcElement;
    if (contains(this.anchor, target))
      return;
    if (contains(this.cloud, target))
      return;
    this.hideTimeoutHandler = setTimeout(this.fadeAway.bind(this), this.hideTimeout);
  }
}



// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/formattableTitle/index.js